import React from 'react';
import T from 'prop-types';

const NA = <span className="text-muted">Not Available</span>;

const renderValue = (value, render) => (render ? render(value) : value) || NA;

const Row = ({ label, children }) => (
  <tr>
    <td className="text-bold p-l-0 v-a-t publisher_page_company_contacts__info_label">{label}:</td>
    <td>{children}</td>
  </tr>
);

const CompanyInfo = ({ company, publisherName }) => {
  const name = company.company_name || publisherName;

  return (
    <div>
      <h3 className="text-md m-b-lg">Company Information</h3>
      {company.logo_url && (
        <img
          className="img-fluid m-b publisher_page_company_contacts__logo"
          src={company.logo_url}
          alt={`${name} Logo`}
        />
      )}
      <div className="table-responsive pos-rel">
        <table className="table table-lg">
          <tbody className="text-xxs">
            <Row label="Company Name">{`"${name}"`}</Row>
            <Row label="Description">{renderValue(company.short_description)}</Row>
            <Row label="Categories">{renderValue(company.categories)}</Row>
            <Row label="Employee Count">{renderValue(company.employee_count)}</Row>
            <Row label="Headquarters">{renderValue(company.headquarters)}</Row>
            <Row label="Zipcode">{renderValue(company.zipcode)}</Row>
            <Row label="Email">
              {renderValue(company.email, (v) => (
                <a href={`mailto:${v}`}>{v}</a>
              ))}
            </Row>
            <Row label="Phone">{renderValue(company.phone)}</Row>
            <Row label="Founded">{renderValue(company.founded_on)}</Row>
            <Row label="Website">
              {renderValue(company.website_url, (v) => (
                <a href={v} target="_blank" rel="noopener noreferrer">
                  {company.website_text || v}
                </a>
              ))}
            </Row>
            <Row label="Facebook">
              {renderValue(company.facebook_url, (v) => (
                <a href={v} target="_blank" rel="noopener noreferrer">
                  {company.facebook_text || v}
                </a>
              ))}
            </Row>
            <Row label="X">
              {renderValue(company.twitter_url, (v) => (
                <a href={v} target="_blank" rel="noopener noreferrer">
                  {company.twitter_text || v}
                </a>
              ))}
            </Row>
            <Row label="LinkedIn">
              {renderValue(company.linkedin_url, (v) => (
                <a href={v} target="_blank" rel="noopener noreferrer">
                  {company.linkedin_text || v}
                </a>
              ))}
            </Row>
            <Row label="Crunchbase">
              {renderValue(company.cb_url, (v) => (
                <a href={v} target="_blank" rel="noopener noreferrer">
                  {v}
                </a>
              ))}
            </Row>
          </tbody>
        </table>
      </div>
    </div>
  );
};

CompanyInfo.propTypes = {
  company: T.object.isRequired,
  publisherName: T.string,
};

export default CompanyInfo;
